import React from "react";
import SecondaryHeading from "../../components/common/Typography/SecondaryHeading";
import Facebook from "../../assets/img/social/facebook.svg";
import Instagram from "../../assets/img/social/instagram.svg";
import Linkiedin from "../../assets/img/social/linkedin.svg";
import Twitter from "../../assets/img/social/threads.svg";
import Tiktok from "../../assets/img/social/tiktok.svg";
import Pinterest from "../../assets/img/social/pinterest.svg";
import Paragraph from "../../components/common/Typography/Paragraph";

const Social = () => {
  const data = [
    { platform: "Facebook", logo: Facebook },
    { platform: "Instagram", logo: Instagram },
    { platform: "Linkiedin", logo: Linkiedin },
    { platform: "Twitter", logo: Twitter },
    { platform: "Tiktok", logo: Tiktok },
    { platform: "Pinterest", logo: Pinterest },
  ];

  const iconMap = {
    Facebook: "fi fi-brands-facebook",
    Instagram: "fi fi-brands-instagram",
    Linkiedin: "fi fi-brands-linkedin",
    Twitter: "fi fi-brands-twitter",
    Tiktok: "fi fi-brands-tik-tok",
    Pinterest: "fi fi-brands-pinterest",
  };

  return (
    <>
      <SecondaryHeading
        variant={"MainParagraphHeading"}
        className={"text-offblack mb-3"}
      >
        Social Profiles
      </SecondaryHeading>
      <div className="flex flex-col gap-4 items-start">
        {data.map((e, index) => (
          <a
            key={index}
            href="#"
            className="flex flex-row items-center gap-3 group transition-colors duration-200 items-center"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className={`${iconMap[e.platform]} text-[20px] text-offblack transition-colors duration-200 flex items-center`}></i>
            <Paragraph variant={"MainParagraph"} className="text-offblack text-sm group-hover:text-primaryblue transition-colors duration-200">
              {e.platform}
            </Paragraph>
          </a>
        ))}
      </div>
    </>
  );
};

export default Social;
